<div id="content-modal">
  <header>
    <h3>{{ title ? title : '' }}</h3>
    <button
      (click)="modalService.closeModal()"
      [tooltip]="'content_modal.exit_fullscreen' | translate"
      tooltipPosition="left"
    >
      <kin-icon name="close" />
    </button>
  </header>
  <ng-container *ngComponentOutlet="component; inputs: data.inputs" />
</div>
